import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={80}
        height={80}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 80 80`}
        >
        <path d="M10 0h70L0 80V10A10 10 0 0 1 10 0Z"   fill={props.color} />

    </svg>
)

export default SvgComponent
